import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

// Customer-support agent: smiling face wearing a headset with a mic boom.
// Uses currentColor so it follows the surrounding text colour.
const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round"
};

const SupportAgentIcon = props => (
  <SvgIcon {...props}>
    <path {...stroke} strokeWidth="1.4" d="M3.3 12.5a8.7 8.7 0 0 1 17.4 0" />
    <rect x="2" y="11" width="2.6" height="4.8" rx="1.3" />
    <rect x="19.4" y="11" width="2.6" height="4.8" rx="1.3" />
    <path {...stroke} strokeWidth="1.2" d="M3.3 15.6c.4 3.8 3.6 5.8 7.6 5.8" />
    <circle cx="11.6" cy="21.4" r="1.05" />
    <circle {...stroke} strokeWidth="1.5" cx="12" cy="13" r="6.9" />
    <path d="M5.2 12.2A6.9 6.9 0 0 1 18.8 11.6c-2.4-.2-4.4-1.4-5.6-3.3-1.3 2.3-4.4 3.8-8 3.9z" />
    <circle cx="9.4" cy="14" r="1.1" />
    <circle cx="14.6" cy="14" r="1.1" />
    <path d="M10.1 16.4h3.8a1.9 1.9 0 0 1-3.8 0z" />
  </SvgIcon>
);

export default SupportAgentIcon;
